import { render, staticRenderFns } from "./StaffDeleted.vue?vue&type=template&id=96f5b564&scoped=true&"
import script from "./StaffDeleted.vue?vue&type=script&lang=js&"
export * from "./StaffDeleted.vue?vue&type=script&lang=js&"
import style0 from "./StaffDeleted.vue?vue&type=style&index=0&id=96f5b564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f5b564",
  null
  
)

export default component.exports